// extracted by mini-css-extract-plugin
module.exports = {"cell":"TableCell_cell__1NAWS","button":"TableCell_button__2zf6c","check":"TableCell_check__JSrXh","input":"TableCell_input__3wWsE"};